import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';

export const STAGE = {
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  COMPLETED: 'completed',
};

const initialState = {
  stage1: STAGE.AVAILABLE,
  stage2: STAGE.UNAVAILABLE,
  loading: true,
  retry: null,
  errorCount: 0,
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setStages': {
      const { refreshCompleted, reportCompleted } = payload;
      const stage1 = refreshCompleted ? STAGE.COMPLETED : STAGE.AVAILABLE;
      const stage2 = (() => {
        if (reportCompleted) return STAGE.COMPLETED;
        return stage1 === STAGE.COMPLETED ? STAGE.AVAILABLE : STAGE.UNAVAILABLE;
      })();
      return {
        ...state,
        stage1,
        stage2,
      };
    }
    case 'completeStage1':
      return {
        ...state,
        stage1: STAGE.COMPLETED,
        stage2:
          state.stage2 === STAGE.UNAVAILABLE ? STAGE.AVAILABLE : state.stage2,
      };
    case 'setLoading':
      return {
        ...state,
        loading: payload,
      };
    case 'incrError':
      return {
        ...state,
        retry: payload,
        errorCount: state.errorCount + 1,
      };
    case 'resetError':
      return {
        ...state,
        retry: null,
        errorCount: 0,
      };
    default:
      return { ...state };
  }
};

const NetworkIssuesContext = createContext();

const NetworkIssuesProvider = ({ children, initial }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const contextValue = {
    ...state,
    ...initial,
    setStages: payload => dispatch({ type: 'setStages', payload }),
    completeStage1: () => dispatch({ type: 'completeStage1' }),
    setLoading: payload => dispatch({ type: 'setLoading', payload }),
    incrError: payload => dispatch({ type: 'incrError', payload }),
    resetError: () => dispatch({ type: 'resetError' }),
  };

  return (
    <NetworkIssuesContext.Provider value={contextValue}>
      {children}
    </NetworkIssuesContext.Provider>
  );
};

NetworkIssuesProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initial: PropTypes.shape({}),
};

NetworkIssuesProvider.defaultProps = {
  initial: {},
};

export { NetworkIssuesContext as default, NetworkIssuesProvider };
